export default __webpack_public_path__ + "static/media/green_up_arrow.1ebf7d62.svg";